<script>
/**
 * @overview 全局列表容器
 *
 * @author huojinzhao
 */

export default {
  name: "AppList",
};
</script>

<template>
  <div class="app-list">
    <slot name="header" />

    <div class="app-list-main">
      <slot />
    </div>

    <slot name="footer">
      <AppPagination
        v-if="$attrs.list"
        :list="$attrs.list"
        :size="$attrs.size"
        class="app-list-pagination"
        router
      />
    </slot>
  </div>
</template>

<style lang="postcss">
.app-list {
  flex-grow:  1;
  display: flex;
  flex-direction: column;
}

.app-list-main {
  flex: auto;
  display: flex;
  align-content: flex-start;
  padding: 1em;
  flex-wrap: wrap;
}

.app-list-pagination {
  width: 100%;
  margin-bottom: 1em;
  align-self: flex-end;
}
</style>
